// Per-feature promo content registry — Task G.1.
//
// Each feature key maps to a `PromoContent` shown by the modal mounted at
// `#share-promo-modal-host`. Three flagship features (recorder/versions/
// library) get hand-tailored copy + screenshots; the rest reuse a generic
// fallback that just names the feature. Adding new feature keys is the
// only thing G.2-G.4 need to do — the modal itself reads from this map.

export interface PromoContent {
  title: string;
  body: string;
  imageUrl?: string;
  ctaLabel: string;
  ctaUrl: string;
}

const DOWNLOAD = 'https://github.com/neodisa/band-way/releases/latest';

const generic = (featureName: string): PromoContent => ({
  title: 'This feature lives in Band Way desktop',
  body: `${featureName} is available in Band Way for Mac.`,
  ctaLabel: 'Get Band Way',
  ctaUrl: DOWNLOAD,
});

export const PROMO_CONTENT: Record<string, PromoContent> = {
  recorder: {
    title: 'Record multi-track',
    body: 'Band Way captures every mixer channel to its own WAV, sample-accurate. Simple mode hits REC; advanced mode arms per track.',
    imageUrl: '/promo/recorder.webp',
    ctaLabel: 'Get Band Way',
    ctaUrl: DOWNLOAD,
  },
  versions: {
    title: 'Save rehearsal takes',
    body: 'Each recording is a separate take with notes and rating. Compare takes, return to earlier ones.',
    imageUrl: '/promo/versions.webp',
    ctaLabel: 'Get Band Way',
    ctaUrl: DOWNLOAD,
  },
  library: {
    title: 'Full song library',
    body: 'Stem import, bar grid, metronome, setlists — everything you need to prep for a service.',
    imageUrl: '/promo/library.webp',
    ctaLabel: 'Get Band Way',
    ctaUrl: DOWNLOAD,
  },
  setlist: generic('Setlists — song order for a service'),
  settings: generic('Device settings, latency calibration, themes'),
  trackIO: generic('Track routing to mixer channels'),
  notes: generic('Song notes'),
  zoom: generic('5× zoom for precise bar editing'),
  metronome: generic('Metronome with count-in and tap-tempo'),
  // 53-я additions
  stage: {
    title: '◈ Stage mode',
    body: 'Backup playback for live: compact window, minimal controls, all via keyboard shortcuts. In the desktop app.',
    ctaLabel: 'Get Band Way',
    ctaUrl: DOWNLOAD,
  },
  export: {
    title: 'Export stems and mix',
    body: 'Export each track separately (stems) or a mixed WAV/MP3 for sharing or mastering. In the desktop app.',
    ctaLabel: 'Get Band Way',
    ctaUrl: DOWNLOAD,
  },
  'track-mixer': {
    title: 'Track mixer',
    body: 'Volume / pan / mute / solo per track, routing to mixer channels. In the desktop app.',
    ctaLabel: 'Get Band Way',
    ctaUrl: DOWNLOAD,
  },
};
